export type UserRole = "NORMAL_USER" | "REVIEWER" | "ADMIN";

export interface NavigationItem {
  key: string;
  label: string;
  path: string;
  icon: "folder" | "audit" | "team" | "file-search" | "safety" | "upload";
}

const NAVIGATION_BY_ROLE: Readonly<Record<UserRole, readonly NavigationItem[]>> = {
  NORMAL_USER: [
    { key: "projects", label: "我的项目", path: "/projects", icon: "folder" },
    { key: "registrants", label: "登记人信息", path: "/registrants", icon: "team" },
  ],
  REVIEWER: [
    { key: "review-tasks", label: "审核任务", path: "/review-tasks", icon: "file-search" },
  ],
  ADMIN: [
    { key: "admin-projects", label: "项目管理", path: "/admin/projects", icon: "folder" },
    {
      key: "admin-review",
      label: "审核任务",
      path: "/admin/review-assignments",
      icon: "file-search",
    },
    {
      key: "admin-registrants",
      label: "登记人信息",
      path: "/admin/registrants",
      icon: "safety",
    },
    { key: "admin-users", label: "用户管理", path: "/admin/users", icon: "team" },
    { key: "admin-audit", label: "操作日志", path: "/admin/audit-events", icon: "audit" },
  ],
};

const DEFAULT_PATH_BY_ROLE: Readonly<Record<UserRole, string>> = {
  NORMAL_USER: "/projects",
  REVIEWER: "/review-tasks",
  ADMIN: "/admin/projects",
};

export function getNavigationForRole(role: UserRole): readonly NavigationItem[] {
  return NAVIGATION_BY_ROLE[role];
}

export function getDefaultPathForRole(role: UserRole): string {
  return DEFAULT_PATH_BY_ROLE[role];
}
